const ALLOWED_GROUPS = ['V2_', 'CS_'];

export class PermissionUtils {
    static isAllowedGroup(key: string): boolean {
        const groupKey = key.toUpperCase().slice(0, 3);
        return ALLOWED_GROUPS.includes(groupKey);
    }
}
